import { Spinner } from "react-bootstrap";
import styled from "styled-components";

export const StyledSpinner = styled(Spinner)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
